import { DEFAULT_LOCATIONS, DROPDOWN_AUTOCOMPLETE, WALMART_NATIONAL } from 'utils/constants';
import { selectToken, getEnv, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 2a85debfaa7308c2b1c078e7206eeae31acc46a0',
  staging: 'Token 207ce5d5120dfb074c2f6fb5d5f76ba080412cc6',
  prod: 'Token cc501a49a0e8ad0705b7726061c7cfb1727898d9',
};

const token = selectToken(apiTokens);

const walmartNationalConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: getEnv() === 'production' ? 'walmart' : 'walmart-national',

  API_TOKEN: token,
  EMBOLD_CLIENT: WALMART_NATIONAL,
  SHOW_REGION_SELECTOR: true,
  HIGH_QUALITY_INTRO_MODAL: true,
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Bentonville },
  LOGIN_NETWORK_NAME: 'walmartNationalLoggedIn',

  // content
  DISPLAY_NAME: 'Walmart',
  NO_WELCOME_LINK: true,
  FORM_VARIANT: DROPDOWN_AUTOCOMPLETE,
};

export default walmartNationalConfig;
